// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>8</span>&nbsp;&nbsp;If I take the wings of the morning&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and dwell in the uttermost parts of the sea,<br> </p> </div></div>";
// Exports
module.exports = code;